import { Description } from "@material-ui/icons";
import {Individuals} from "../../individuals/enums/Individuals";
import { DirectTestingStatus, Status } from "modules/individuals/enums/Status";
import {NIL as nullID} from 'uuid'


export interface DirectTestingDTO {
    id: string
    individualID: string
    mutationID: string
    directTesting: DirectTestingStatus
    status: Status
}

export class DirectTesting {
    private _id: string
    private _individualID: string
    private _mutationID: string
    private _directTesting: DirectTestingStatus
    private _status: Status


    constructor(p: DirectTestingDTO) {
        this._id = p.id
        this._individualID = p.individualID
        this._mutationID = p.mutationID
        this._directTesting = p.directTesting
        this._status = p.status
    }


    get id(): string {
        return this._id
    }

    set id(id: string) {
        this._id = id
    }
    
    get individualID(): string {
        return this._individualID
    }

    set individualID(individualID: string) {
        this._individualID = individualID
    }

    get mutationID(): string {
        return this._mutationID
    }

    set mutationID(mutationID: string) {
        this._mutationID = mutationID
    }

    get directTesting(): DirectTestingStatus {
        return this._directTesting
    }

    set directTesting(directTesting: DirectTestingStatus) {
        this._directTesting = directTesting
    }

    get status(): Status{
        return this._status
    }
    set status(status: Status){
        this._status = status
    }

    toDTO(): DirectTestingDTO {
        return {
            id: this.id,
            individualID: this.individualID,
            mutationID: this.mutationID,
            directTesting: this.directTesting,
            status: this.status
        }
    }
}

export function toModel(p: DirectTestingDTO): DirectTesting {
    return new DirectTesting(p)
}

export function toDTO(p: DirectTesting): DirectTestingDTO {
    return p.toDTO()
}

export function emptyDirectTesting(): DirectTesting {
    return new DirectTesting({
        id: '',
        individualID: nullID,
        mutationID:  nullID,
        directTesting: 0,
        status: Status.Null
    })
}

export interface DirectTestingQuery {
    id: string
    individualID: string
    mutationID: string
    status: Status
    directTesting: DirectTestingStatus
}